





import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator';

@Component
export default class FlTruncatableSpan extends Vue {
  @Prop({ default: '' }) private value!: string;
  isTruncated: boolean = false;
  mounted() {
    let element: any = this.$refs.span;
    this.isTruncated = element.clientWidth < element.scrollWidth;
  }
}
